import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Locations } from 'src/app/indicator/constraints';

@Component({
  selector: 'app-lite-button-menu',
  templateUrl: './lite-button-menu.component.html',
  styleUrls: ['./lite-button-menu.component.css'],
})
export class LiteButtonMenuComponent implements OnInit {
  @Input() buttonTitle: string;
  @Input() zIndex: string;
  @Input() items: any;
  @Input() expendedFirstTime: boolean;

  private _closeMenu = false;
  @Input()
  set closeMenu(value: boolean) {
    // If closeMenu is set to true, collapse the menu and reset expendedFirstTime
    if (value) {
      this.expended = false;
      this.expendedFirstTime = false;
    }
    this._closeMenu = value;
  }
  get closeMenu(): boolean {
    return this._closeMenu;
  }

  @Output() itemSelected: EventEmitter<any> = new EventEmitter();
  @Output() menuOpened: EventEmitter<void> = new EventEmitter();

  Locations: Locations;
  expended = false;
  title: string;

  ngOnInit() {}

  onToggleButtonClick(event: any) {
    this.expended = !this.expended;
    this.expendedFirstTime = false;

    // When the toggle is expanded, emit the menuOpened event to notify the parent component
    if (this.expended) this.menuOpened.emit();
  }

  onItemClicked(id: any) {
    this.itemSelected.emit(id);
    this.expended = !this.expended;
    this.expendedFirstTime = false;
  }
}
